import { render } from "./OrdersPage.vue?vue&type=template&id=3a41cfa4"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"

import "./OrdersPage.vue?vue&type=style&index=0&id=3a41cfa4&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__